/* eslint-disable */
import React, { useEffect, useState, useRef, useContext, useMemo } from 'react';
import Card from './card.component';
import Modal from './modal/modal.component';
import DataTable from 'react-data-table-component';
import connect from '../views/axios/axios.auth';
import {
    faCheck,
    faSearch,
    faEdit,
    faTrash,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import notification from './notification.component';
import { ConfigContextUtils } from '../context/contextUtils.context';
import { RecipientEdit } from './destinatarioEditTable/InputEditable'; 

const DestinatariosModal = ({ clienteId = null, onSelect }) => {

    const { setPreloader } = useContext(ConfigContextUtils);
    const [visible, setVisible] = useState(false);
    const [listado, setListado] = useState([]);
    const [currentEditable, setCurrentEditable] = useState(null);
    const [recipientDelete, setRecipientDelete] = useState(null);
    const [dataEditable, setDataEditable] = useState(null);

    useEffect(() => {
      if (!visible) {
        setListado([]);
        setCurrentEditable(null);
      }
    },[visible]);

    const editActive = (row) => {
      const uListado = [...listado];
      setDataEditable(row);
      setListado(uListado);
    }

    const deleteRecipient = (row) => {
      setRecipientDelete(row);
    }

    const confirmDelete = () => {
      setPreloader(true);
      connect.post('/cliente/destinatario-remove/', { recipient_id: recipientDelete.id }).then((response) => {
          if (response.data.error) {
            notification.warning(response.data.message);
          } else {
            notification.success(response.data.message);
            const uListado = [...listado];
            const fIndex = uListado.findIndex(({ id }) => id === recipientDelete.id);
            uListado.splice(fIndex, 1);
            setListado(uListado);
            setRecipientDelete(null);
          }
          setPreloader(false);
      })
    }

    const updateData = () => {
      listadoDestinatarios();
      setDataEditable(null);
      setCurrentEditable(null);
    }

    const columnsClientes = [
        {
          name: 'Identificación personal',
          selector: 'cliente_receptor_identificacion',
          sortable: true,
          cell: row => (
            row.cliente_receptor_identificacion
          ),
          width: '15%',
        },
        {
          name: 'Nombre',
          selector: 'cliente_receptor_nombre',
          sortable: true,
          cell: row => (
            row.cliente_receptor_nombre
          ),
          width: '45%',
        },
        {
          name: 'Telefono',
          selector: 'cliente_receptor_telefono',
          sortable: true,
          width: '20%',
          cell: row => (
            row.cliente_receptor_telefono
          ),
        },
        {
          name: '',
          center: true,
          cell: (row) => {
            return row.last_use ? <span className="badge badge-success">ÚLTIMO USADO</span> : null
          }
        },
        {
          name: 'Seleccionar',
          grow: 0,
          right: true,
          cell: row => (
            <>
              <button 
                  onClick={() => selected(row)}
                  type="button"
                  className="btnx btnx-warn mr-1"
                  disabled={!clienteId}>
                      <FontAwesomeIcon icon={faCheck} />
              </button>
              {/*
                <button 
                    onClick={() => editActive(row)}
                    type="button"
                    className="btnx btnx-warn mr-1"
                    disabled={row.editable}
                  >
                        <FontAwesomeIcon icon={faEdit} />
                </button>
                */}
              <button 
                  onClick={() => deleteRecipient(row)}
                  type="button"
                  className="btnx btnx-warn"
                >
                   <FontAwesomeIcon icon={faTrash} />
              </button>
            </>
          )
        },
      ];
      
      const customStyles = {
      rows: {
        style: {
          minHeight: '72px', // override the row height
          paddingTop: '1px',
          paddingBottom: '1px',
        }
      },
      headCells: {
        style: {
          paddingLeft: '8px', // override the cell padding for head cells
          paddingRight: '8px',
        },
      },
      cells: {
        style: {
          paddingLeft: '8px', // override the cell padding for data cells
          paddingRight: '8px',
        },
      },
    };
      
    const listadoDestinatarios = () => {
        connect.post(`/guias/destinatarios`, { clienteId })
        .then((response) => {
          if (response.data.destinatarios.length) {
            response.data.destinatarios[0].last_use = true;
          }
          setListado(response.data.destinatarios);
        })
    }

    useEffect(() => {
        if (visible) {
            listadoDestinatarios();
        }
    },[visible])

    const selected = (row) => {
      if (row.editable) {
        confirmupdate();
      } else {
        onSelect(row);
        setVisible(false);
      }
    }

    const cleandata = () => {
      setDataEditable(null);
      setCurrentEditable(null);
    }


    const getColor = () => {
      let value = -1;
      if (recipientDelete) {
          value = recipientDelete.id;
      }

      return value;
    }

    const conditionalRowBoleta = [
      {
        when: row => row.id === getColor(),
        style: {
          backgroundColor: 'rgba(255, 127, 127, 0.9)',
          color: 'black',
          '&:hover': {
            cursor: 'pointer',
          },
        },
      },
    ];

    return (
        <>
        <button 
            onClick={() => setVisible(true)}
            type="button"
            className="btnx btnx-warn mr-1"
            disabled={!clienteId}>
               <FontAwesomeIcon icon={faSearch} /> Destinatarios
        </button>
        <Modal show={visible} size={'xl'}>
            <Card>
            {dataEditable !== null ? <div className="disabled-modal"></div> : null}
            <DataTable
                title="Destinatarios usados en guias anteriores"
                customStyles={customStyles}
                columns={columnsClientes}
                data={listado}
                dense={true}
                pagination={true}
                paginationPerPage={5}
                paginationRowsPerPageOptions={[5]}
                conditionalRowStyles={conditionalRowBoleta}
                noDataComponent={<div className="m-3">Este cliente no tiene destinatarios anteriores</div>}
            />
            <div className="d-flex justify-content-between">
                <button 
                    onClick={() => setVisible(false)}
                    type="button"
                    className="btnx btnx-warn mr-1"
                    >
                        Cerrar
                </button>
                {recipientDelete !== null ?
                  <div>
                    <button 
                        onClick={() => setRecipientDelete(null)}
                        type="button"
                        className="btnx btnx-warn mr-1"
                        >
                            Cancelar
                    </button>
                    <button 
                        onClick={confirmDelete}
                        type="button"
                        className="btnx btnx-warn mr-1"
                        style={{ backgroundColor: '#FC2D2D' }}
                        >
                            {`Confirmar eliminar el destinatario "${recipientDelete.cliente_receptor_nombre}"`}
                    </button>
                   </div>
                 : null }
            </div>
            </Card>
        </Modal>
        <RecipientEdit data={dataEditable} onUpdate={updateData} onClose={cleandata}/>
        </>
    )
}

export default DestinatariosModal;